import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import FadeInAnimation from '../Common/FadeInAnimation';
import { BiCodeAlt, BiDownload, BiPlug, BiServer } from 'react-icons/bi';

const WooCommerceSchnittstelleIntegration = () => {
    const { t } = useTranslations();

    const integrations = [
        {
            icon: BiDownload,
            title: t('woocommerceSchnittstelle_integration_xml_title'),
            description: t('woocommerceSchnittstelle_integration_xml_desc'),
            features: [
                t('woocommerceSchnittstelle_integration_xml_feature1'),
                t('woocommerceSchnittstelle_integration_xml_feature2'),
                t('woocommerceSchnittstelle_integration_xml_feature3')
            ]
        },
        {
            icon: BiCodeAlt,
            title: t('woocommerceSchnittstelle_integration_json_title'),
            description: t('woocommerceSchnittstelle_integration_json_desc'),
            features: [
                t('woocommerceSchnittstelle_integration_json_feature1'),
                t('woocommerceSchnittstelle_integration_json_feature2'),
                t('woocommerceSchnittstelle_integration_json_feature3')
            ]
        },
        {
            icon: BiPlug,
            title: t('woocommerceSchnittstelle_integration_webhook_title'),
            description: t('woocommerceSchnittstelle_integration_webhook_desc'),
            features: [
                t('woocommerceSchnittstelle_integration_webhook_feature1'),
                t('woocommerceSchnittstelle_integration_webhook_feature2'),
                t('woocommerceSchnittstelle_integration_webhook_feature3')
            ]
        },
        {
            icon: BiServer,
            title: t('woocommerceSchnittstelle_integration_custom_title'),
            description: t('woocommerceSchnittstelle_integration_custom_desc'),
            features: [
                t('woocommerceSchnittstelle_integration_custom_feature1'),
            ]
        }
    ];

    return (
        <section id="features" className="wc-integration pt-100 pb-100">
            <div className="container">
                <div className="row mb-5">
                    <div className="col-12 text-center">
                        <FadeInAnimation direction="up" delay={50}>
                            <span className="wc-section-badge">
                                {t('woocommerceSchnittstelle_integration_badge')}
                            </span>
                            <h2 className="wc-section-title">
                                {t('woocommerceSchnittstelle_integration_title')}
                            </h2>
                            <p className="wc-section-subtitle">
                                {t('woocommerceSchnittstelle_integration_subtitle')}
                            </p>
                        </FadeInAnimation>
                    </div>
                </div>

                <div className="row">
                    {integrations.map((integration, index) => {
                        const Icon = integration.icon;
                        return (
                            <div key={index} className="col-lg-6 col-md-6 mb-4 d-flex">
                                <FadeInAnimation direction="up" delay={100 + (index * 100)} style={{ display: 'flex', width: '100%' }}>
                                    <div className="wc-integration__card">
                                        <div className="wc-integration__icon-box">
                                            <Icon />
                                        </div>
                                        <h3 className="wc-integration__card-title">
                                            {integration.title}
                                        </h3>
                                        <p className="wc-integration__card-desc">
                                            {integration.description}
                                        </p>
                                        <div className="wc-integration__features">
                                            {integration.features.map((feature, featureIndex) => (
                                                <div key={featureIndex} className="wc-integration__feature-item">
                                                    <div className="wc-integration__feature-dot"></div>
                                                    <span className="wc-integration__feature-text">{feature}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </FadeInAnimation>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default WooCommerceSchnittstelleIntegration;
